import React, { useState } from 'react';
import MaterialAdminModal from '../admin/MaterialAdminModal';

const AdminGeneralTable = ({ 
  materials, 
  handleUpdateFile, 
  handleDeleteFile, 
  downloadFile, 
  orderId 
}) => {
  const [displayModal, setDisplayModal] = useState(false);
  const [conciliationList, setConciliationList] = useState([]);

  const openModal = (materialStatus) => {
    setConciliationList(materialStatus.conciliation_list);
    setDisplayModal(true);
  };

  const closeModal = () => {
    setConciliationList([]);
    setDisplayModal(false);
  };

  // Helper function para obtener el estado visual
  const getStatusBadge = (condition, trueText = 'Sí', falseText = '') => {
    if (condition) {
      return (
        <span className="tag is-success is-light" style={{ fontWeight: '600', fontSize: '0.9rem' }}>
          <span className="icon is-small mr-1">
            <i className="fas fa-check"></i>
          </span>
          <span>{trueText}</span>
        </span>
      );
    }
    return falseText ? (
      <span className="tag is-light" style={{ fontWeight: '600', fontSize: '0.9rem' }}>
        <span className="icon is-small mr-1">
          <i className="fas fa-times"></i>
        </span>
        <span>{falseText}</span>
      </span>
    ) : null;
  };

  // Helper function para datos faltantes
  const getDataOrEmpty = (data, emptyText = 'Sin datos') => {
    return data ? (
      <span className="has-text-weight-semibold">{data}</span>
    ) : (
      <span className="has-text-weight-semibold is-italic">
        {emptyText}
      </span>
    );
  };

  return (
    <div>
      <MaterialAdminModal
        displayModal={displayModal}
        closeModal={closeModal}
        conciliationFiles={conciliationList}
        handleUpdateFile={handleUpdateFile}
        handleDeleteFile={handleDeleteFile}
        downloadFile={downloadFile}
        orderId={orderId}
      />

      <div className="box p-0" style={{ borderRadius: '8px', overflow: 'hidden', boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)' }}>
        <div className="table-container">
          <table className="table is-bordered is-striped is-hoverable is-fullwidth mb-0">
            <thead>
              <tr className="has-background-primary" style={{ backgroundColor: '#f8f9fa', borderBottom: '2px solid #dee2e6' }}>
                <th className="has-text-white" style={{ padding: '1rem 0.75rem', backgroundColor: '#3273dc', color: 'white' }}>
                  <span className="icon-text">
                    <span className="icon is-small mr-2">
                      <i className="fas fa-user"></i>
                    </span>
                    <span className="has-text-weight-bold">Usuario</span>
                  </span>
                </th>
                <th className="has-text-white" style={{ padding: '1rem 0.75rem', backgroundColor: '#3273dc', color: 'white' }}>
                  <span className="icon-text">
                    <span className="icon is-small mr-2">
                      <i className="fas fa-broadcast-tower"></i>
                    </span>
                    <span className="has-text-weight-bold">Medio</span>
                  </span>
                </th>
                <th className="has-text-white" style={{ padding: '1rem 0.75rem', backgroundColor: '#3273dc', color: 'white' }}>
                  <span className="icon-text">
                    <span className="icon is-small mr-2">
                      <i className="fas fa-file-alt"></i>
                    </span>
                    <span className="has-text-weight-bold">Material</span>
                  </span>
                </th>
                <th className="has-text-white has-text-centered" style={{ padding: '1rem 0.75rem', backgroundColor: '#3273dc', color: 'white' }}>
                  <span className="icon-text">
                    <span className="icon is-small mr-2">
                      <i className="fas fa-eye"></i>
                    </span>
                    <span className="has-text-weight-bold">Orden Vista</span>
                  </span>
                </th>
                <th className="has-text-white has-text-centered" style={{ padding: '1rem 0.75rem', backgroundColor: '#3273dc', color: 'white' }}>
                  <span className="icon-text">
                    <span className="icon is-small mr-2">
                      <i className="fas fa-download"></i>
                    </span>
                    <span className="has-text-weight-bold">Material Descargado</span>
                  </span>
                </th>
                <th className="has-text-white" style={{ padding: '1rem 0.75rem', backgroundColor: '#3273dc', color: 'white' }}>
                  <span className="icon-text">
                    <span className="icon is-small mr-2">
                      <i className="fas fa-map-marker-alt"></i>
                    </span>
                    <span className="has-text-weight-bold">Domicilio</span>
                  </span>
                </th>
                <th className="has-text-white" style={{ padding: '1rem 0.75rem', backgroundColor: '#3273dc', color: 'white' }}>
                  <span className="icon-text">
                    <span className="icon is-small mr-2">
                      <i className="fas fa-phone"></i>
                    </span>
                    <span className="has-text-weight-bold">Teléfono</span>
                  </span>
                </th>
                <th className="has-text-white has-text-centered" style={{ padding: '1rem 0.75rem', backgroundColor: '#3273dc', color: 'white' }}>
                  <span className="icon-text">
                    <span className="icon is-small mr-2">
                      <i className="fas fa-code"></i>
                    </span>
                    <span className="has-text-weight-bold">H.P.</span>
                  </span>
                </th>
                <th className="has-text-white has-text-centered" style={{ padding: '1rem 0.75rem', backgroundColor: '#3273dc', color: 'white' }}>
                  <span className="icon-text">
                    <span className="icon is-small mr-2">
                      <i className="fas fa-language"></i>
                    </span>
                    <span className="has-text-weight-bold">H.T.</span>
                  </span>
                </th>
                <th className="has-text-white has-text-centered" style={{ padding: '1rem 0.75rem', backgroundColor: '#3273dc', color: 'white' }}>
                  <span className="icon-text">
                    <span className="icon is-small mr-2">
                      <i className="fas fa-tape"></i>
                    </span>
                    <span className="has-text-weight-bold">C.T.</span>
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
              {materials.map((material, index) => {
                const { description, status: users } = material;
                
                if (users && users.length > 0) {
                  return users.map((materialStatus, userIndex) => (
                    <tr 
                      key={`${index}-${userIndex}`}
                      className="is-clickable hover-row"
                      style={{ 
                        background: materialStatus.material_status,
                        cursor: 'pointer',
                        transition: 'all 0.2s ease',
                        borderLeft: '4px solid transparent',
                        padding: '1rem 0.75rem'
                      }}
                      onClick={() => openModal(materialStatus)}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.05)';
                        e.currentTarget.style.transform = 'translateY(-1px)';
                        e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.1)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = materialStatus.material_status;
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = 'none';
                      }}
                    >
                      <td className="has-text-weight-semibold is-vcentered" style={{ padding: '1rem 0.75rem', verticalAlign: 'middle' }}>
                        <span className="icon-text">
                          <span className="has-text-weight-medium">{materialStatus.user}</span>
                        </span>
                      </td>
                      <td className="is-vcentered" style={{ padding: '1rem 0.75rem', verticalAlign: 'middle' }}>
                        <span className="tag is-info is-light" style={{ fontWeight: '600', fontSize: '0.9rem' }}>
                          {materialStatus.media}
                        </span>
                      </td>
                      <td className="has-text-weight-semibold is-vcentered" style={{ padding: '1rem 0.75rem', verticalAlign: 'middle' }}>
                        <span className="has-text-weight-medium">{description}</span>
                      </td>
                      <td className="has-text-centered is-vcentered" style={{ padding: '1rem 0.75rem', verticalAlign: 'middle' }}>
                        {getStatusBadge(materialStatus.seen)}
                      </td>
                      <td className="has-text-centered is-vcentered" style={{ padding: '1rem 0.75rem', verticalAlign: 'middle' }}>
                        {getStatusBadge(materialStatus.downloaded)}
                      </td>
                      <td className="is-size-7 is-vcentered" style={{ padding: '1rem 0.75rem', verticalAlign: 'middle' }}>
                        {getDataOrEmpty(materialStatus.address)}
                      </td>
                      <td className="is-size-7 is-vcentered" style={{ padding: '1rem 0.75rem', verticalAlign: 'middle' }}>
                        {getDataOrEmpty(materialStatus.phone_number)}
                      </td>
                      <td className="has-text-centered is-vcentered" style={{ padding: '1rem 0.75rem', verticalAlign: 'middle' }}>
                        {getStatusBadge(materialStatus.prog_file)}
                      </td>
                      <td className="has-text-centered is-vcentered" style={{ padding: '1rem 0.75rem', verticalAlign: 'middle' }}>
                        {getStatusBadge(materialStatus.trans_file)}
                      </td>
                      <td className="has-text-centered is-vcentered" style={{ padding: '1rem 0.75rem', verticalAlign: 'middle' }}>
                        {getStatusBadge(materialStatus.test_file)}
                      </td>
                    </tr>
                  ));
                }
                
                return (
                  <tr key={`no-users-${index}`} className="has-background-warning-light hover-row" style={{ borderLeft: '4px solid #ff7043', transition: 'all 0.2s ease' }}>
                    <td colSpan="3" className="has-text-centered is-vcentered" style={{ padding: '1rem 0.75rem', verticalAlign: 'middle' }}>
                      <span className="icon-text has-text-warning">
                        <span className="icon mr-2">
                          <i className="fas fa-exclamation-triangle"></i>
                        </span>
                        <span className="has-text-weight-semibold">
                          No hay usuarios registrados para el afiliado
                        </span>
                      </span>
                    </td>
                    <td className="is-vcentered" style={{ padding: '1rem 0.75rem', verticalAlign: 'middle' }}>
                      <span className="tag is-warning is-light" style={{ fontWeight: '600', fontSize: '0.9rem' }}>
                        {material.media}
                      </span>
                    </td>
                    <td className="has-text-weight-semibold is-vcentered" style={{ padding: '1rem 0.75rem', verticalAlign: 'middle' }}>
                      <span className="has-text-weight-medium">{material.description}</span>
                    </td>
                    <td colSpan="5" className="has-text-centered has-text-grey-light is-vcentered" style={{ padding: '1rem 0.75rem', verticalAlign: 'middle' }}>
                      <span className="icon-text">
                        <span className="icon mr-2">
                          <i className="fas fa-minus"></i>
                        </span>
                        <span className="is-italic">Sin datos disponibles</span>
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        {materials.length === 0 && (
          <div className="has-text-centered py-6">
            <span className="icon-text has-text-grey">
              <span className="icon is-large mr-3">
                <i className="fas fa-inbox fa-2x"></i>
              </span>
              <span className="is-size-5">No hay materiales disponibles</span>
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminGeneralTable;